import { queryClient } from '@/api/queryClient';

/**
 * Service Worker'dagi API keshlari (vite.config.ts → `runtimeCaching`).
 *
 * Workbox javobni faqat URL bo'yicha saqlaydi — `Authorization` sarlavhasini
 * hisobga olmaydi. Shuning uchun foydalanuvchi almashganda (impersonatsiya,
 * adminga qaytish) yangi shaxsga OLDINGI shaxsning javobi berilib yuborilardi:
 * `catalog-cache` (StaleWhileRevalidate) birinchi yuklanishda doim eski javobni
 * qaytaradi, fonda yangilaydi — shu sabab sahifa faqat IKKINCHI refresh'da
 * to'liq ochilardi. Rasm/shrift keshlari shaxsga bog'liq emas — tegilmaydi.
 */
export const IDENTITY_SCOPED_SW_CACHES = ['catalog-cache', 'orders-cache', 'stores-stock-cache'] as const;

async function clearSwApiCaches(): Promise<void> {
  if (typeof caches === 'undefined') return;
  await Promise.all(IDENTITY_SCOPED_SW_CACHES.map((name) => caches.delete(name).catch(() => false)));
}

/**
 * Foydalanuvchi almashishidan oldin chaqiriladi: xotiradagi (TanStack Query)
 * va Service Worker'dagi shaxsga bog'liq keshni tozalaydi. `await` qilinadi —
 * aks holda sahifa qayta yuklanib, SW eski javobni ulgurib qaytarib yuboradi.
 */
export async function resetIdentityCaches(): Promise<void> {
  queryClient.clear();
  try {
    await clearSwApiCaches();
  } catch {
    // Kesh o'chmasa ham kirish/chiqish bloklanmaydi
  }
}
